<template>
  <div
    id="$address-book$"
    class="address-book fb-col-start-start"
    :class="{ 'pb-48': computedNodes.length > 0 }"
    :style="computedSizeStyle"
  >
    <common-timer
      v-if="isDentention && showTimer"
      :default-active="defaultActive"
      :is-visible="showTimer"
      @cancel="cancelTimer"
      @confirm="confirmTimer"
    ></common-timer>
    <template v-if="showSelectDetail">
      <!-- 查看详情 -->
      <div class="width-full height-full fb fb-col">
        <div class="item-flex-1 scroll pt-12 pb-60" refs="scroller">
          <div
            v-for="(item, index) in cpSelectedStudents"
            :key="item.studentDingId"
            class="bg-FFFFFF pl-16"
            :class="{
              'mb-12': index === cpSelectedStudents.length - 1
            }"
          >
            <studentHead
              :is-dept="!item.studentDingId"
              :student-info="item"
              show-all-class
              :show-padding-right="false"
              max-width="300"
            ></studentHead>
          </div>
        </div>
        <div class="footer fixed bottom-0 fb fb-main-center fb-cross-center">
          <md-button
            type="primary"
            size="medium"
            @click="showSelectDetail = false"
            >确定</md-button
          >
        </div>
      </div>
    </template>
    <template v-else>
      <!-- 成员搜索输入框 -->
      <common-search-input-box
        v-if="computedIsShowSearchBox"
        placeholder="搜索学生姓名"
        :delay="this.role === LEAVE_ROLE.admin ? 1000 : 0"
        @search="handlerToSearchMembers"
        @focus="isFocus = true"
        @blur="isFocus = false"
      ></common-search-input-box>
      <!-- 标签 -->
      <div
        v-if="!searchKey && isShowTag && deptTagList && deptTagList.length > 1"
        class="bg-FFFFFF fb fb-cross-center font-30 bb h-48 item-shrink-0"
      >
        <div
          v-for="tag in deptTagList"
          :key="tag.tagId"
          class="item-flex-1 h-48 lh-48 font-30 text-center relative"
          :class="{
            'c-171A1D': tagId === tag.tagId,
            'c-171A1D-56': tagId !== tag.tagId
          }"
          @click="handlerTagId(tag.tagId)"
        >
          <div v-if="tagId === tag.tagId" class="tab-bottom"></div>
          {{ tag.tagName }}
        </div>
      </div>
      <!-- 部门层级导航 -->
      <common-node-nav
        v-if="compuedIsShowNodeNav"
        :nodeNav="nodeNav"
        class="h-44 item-shrink-0"
        :class="
          (!searchKey && isShowTag && deptTagList && deptTagList.length > 1) ||
          computedIsShowSearchBox
            ? ''
            : 'mt-10'
        "
        ref="nodeNav"
        @click="handlerToGoBackTargetNode"
      ></common-node-nav>
      <!-- 全选 -->
      <div
        v-if="compuedIsShowSelectAll"
        class="select-all fb-start-center font-34"
        @click="handlerToChangeSelectAllStatus"
      >
        <span class="mr-8 mt-2">
          <i v-show="!compuedIsSelectedAll" class="iconfont c-171A1D-40 font-44"
            >&#xe66f;</i
          >
          <i v-show="compuedIsSelectedAll" class="iconfont c-006AFE font-44"
            >&#xe66e;</i
          >
        </span>
        <span class="item-flex-1">全选</span>
      </div>
      <!-- 搜索的时候没有数据 -->
      <div
        v-show="!computedNodes.length && searchKey"
        class="mt-60 h-full c-171A1D-56 fb-col-center-center item-flex-1 bg-no-data"
      >
        <span class="font-34">没有符合搜索条件的记录</span>
      </div>
      <!-- 非搜索的时候没有数据 -->
      <div
        v-show="!computedNodes.length && !searchKey"
        class="mt-60 h-full c-171A1D-56 fb-col-center-center item-flex-1 icon-no-data-box"
      >
        <div class="icon-no-data"></div>
        <span class="font-34">暂无学生</span>
      </div>
      <!-- 子级部门列表/搜索结果成员列表 -->
      <div v-if="computedNodes.length > 0" class="node-list font-34">
        <div
          v-for="(node, idx) in computedNodes"
          class="fb-start-center h-56"
          :class="{
            'disabled-choose': computedIsDisabled(node),
            'h-auto': node.studentDingId
          }"
          :key="node.tpId"
          @click="handlerToChangeSelectedStatus(node)"
        >
          <span v-if="computedIsShowSelectBox(node)" class="mr-12 mt-2">
            <i
              v-show="!computedIsSelected(node)"
              class="iconfont c-171A1D-40 font-48"
              >&#xe66f;</i
            >
            <i
              v-show="computedIsSelected(node)"
              class="iconfont c-006AFE font-48"
              >&#xe66e;</i
            >
          </span>
          <div
            class="item-flex-1 fb fb-cross-center hidden"
            :class="{ bb: idx < computedNodes.length - 1 }"
            style="height: 100%"
          >
            <studentHead
              v-if="node.studentDingId"
              :student-info="node"
              show-all-class
              :show-padding-right="false"
              max-width="300"
            ></studentHead>
            <template v-else>
              <div class="item-flex-1 hidden h-full">
                <div class="fb fb-col fb-main-center h-full hidden">
                  <div class="fb fb-main-start fb-cross-center hidden">
                    <span class="font-34 pr-5 text-ellipsis w-adapt">{{
                      node.name
                    }}</span>
                  </div>
                </div>
              </div>
            </template>

            <span
              v-if="computedIsCanOpen(node)"
              class="next item-shrink-0"
              :class="{ 'disabled-choose': computedIsSelected(node) }"
              @click.stop="handlerToGetSubNodes(node)"
            >
              <i class="iconfont">&#xe714;</i>下级
            </span>
          </div>
        </div>
      </div>
      <div
        v-if="computedNodes.length > 0"
        class="result font-26 fb-start-center"
      >
        <div
          class="item-flex-1 text-ellipsis c-006AFE"
          @click.stop="handlerViewDetail"
        >
          <span>{{ computedResultText }}</span>
        </div>
        <div>
          <common-button
            width="95"
            height="32"
            @click="handlerToSubmit(false, false)"
            >确定</common-button
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  commonSearchInputBox,
  commonNodeNav,
  commonButton
} from '@/components/commonAddressBook'
import { commonTimer, studentHead } from '@/components'
import { LEAVE_ROLE, NODE_TYPE } from '@/utils/constUtils'
import {
  timeFormat,
  minutesLater,
  deepCopy,
  getCombineRole,
  setLeft,
  removeLeft,
  pushNullUrl
} from '@/utils/comUtils'

import API from '@/api'
import {
  mcShowPreloader,
  mcHidePreloader,
  mcConfirm,
  mcToast,
  mcSetTitle
} from '@/utils/mcSdkUtils'

// 选择类型
const SELECT_TYPE = {
  none: 0, // 所有节点都可勾选(默认)
  class: 3, // 仅班级（通用）
  student: 4, // 仅学生
  dept: 4, // 自定义校区部门层级
  members: 5 // 自定义校区人员
}

// 返回值类型
const RETURN_TYPE = {
  none: 0, // 返回魔点Id(默认)
  dingId: 1, // 返回钉钉Id
  node: 2, // 返回魔点节点对象（含魔点Id）
  dingNode: 3 // 返回钉钉节点对象（含钉钉Id）
}

export default {
  name: 'MSchoolAddressBook',
  components: {
    commonSearchInputBox,
    commonNodeNav,
    commonButton,
    commonTimer,
    studentHead
  },
  props: {},
  data() {
    return {
      LEAVE_ROLE,
      searchKey: '', // 成员搜索关键字
      isFocus: false,
      nodeNav: [], // 部门导航条
      depts: [], // 校区列表
      students: [], // 学生列表
      currentType: 1, // 当前层级
      currentTypeBase: 1, // 存储当前层级
      selectedDeptNodes: [], // 已勾选校区、学段、年级、年级节点列表(仅限多选)
      selectedMemberNodes: [], // 已勾选学生和家长节点列表(仅限多选)
      selectedNode: null, // 已勾选节点(仅限单选)
      defaultSelected: {},
      allClassDetail: [],
      searchMembers: [],
      currentCampus: {},
      showCampusList: false,
      deptTagList: [], // 选择部门时，标签选择
      showTimer: false,
      defaultActive: [0, 0],
      showConfirm: false,
      showSelectDetail: false
    }
  },
  computed: {
    cpIsSelectDept() {
      return [3].includes(this.endType)
    },
    /**
     * 计算组件尺寸大小
     */
    computedSizeStyle() {
      return {
        width: `${window.innerWidth}px`,
        height: `${window.innerHeight}px`
      }
    },
    /*
     *判断是否显示搜索框
     */
    computedIsShowSearchBox() {
      return this.selectType === 5 && this.role !== LEAVE_ROLE.guardian
    },
    /*
     *判断是否显示全选选项
     */
    compuedIsShowSelectAll() {
      // 仅限非家长 && 多选 && 当前列表可选时显示
      return (
        !!this.multiple &&
        this.computedNodes.length > 0 &&
        (this.selectType === SELECT_TYPE.none ||
          this.computedIsShowSelectBox(this.computedNodes[0]))
      )
    },
    /**
     * 判断当前节点列表是否已全选
     */
    compuedIsSelectedAll() {
      let _nodes = this.computedNodes
      let _isSelectAll = false
      if (_nodes.every(node => this.computedIsDisabled(node))) {
        _isSelectAll = false
      } else {
        _isSelectAll = _nodes.every(
          node =>
            this.methodFindNodeIndex(node) !== -1 ||
            this.computedIsDisabled(node)
        )
      }
      return _isSelectAll
    },
    /*
     *判断是否显示部门导航条
     */
    compuedIsShowNodeNav() {
      // 仅限非家长，且非搜索状态时显示
      return !this.searchKey && this.role !== LEAVE_ROLE.guardian
    },
    /**
     * 判断是否显示搜索结果
     */
    computedIsShowSearchResult() {
      return this.searchKey && this.currentType === SELECT_TYPE.members
    },
    /**
     * 当前展示部门
     */
    computedNodes() {
      let _nodes = []
      if (this.currentType === SELECT_TYPE.members) {
        _nodes = this.searchKey ? this.searchMembers : this.students
      } else if (this.role === LEAVE_ROLE.guardian) {
        _nodes = this.students
      } else {
        _nodes = this.depts
      }
      if (
        this.role === LEAVE_ROLE.customRole &&
        (this.rangeList || []).length
      ) {
        // 自定义角色下 如果为学生列表，不用进行筛选
        _nodes = _nodes.filter(v => v.allowed || v.studentDingId)
      }
      return _nodes
    },
    /**
     * 计算当前节点是否显示勾选框
     */
    computedIsShowSelectBox(node) {
      return node => {
        let _result = false
        if (this.selectType === SELECT_TYPE.none) {
          _result = true
        } else {
          _result =
            node.deptType ===
            (this.selectType === 3 ? SELECT_TYPE.class : SELECT_TYPE.members)
        }

        return _result
      }
    },
    /**
     * 计算当前节点是否可操作
     */
    computedIsDisabled(node) {
      return node => {
        let _result = false
        let _isDept = this.methodCheckIsDept(node)
        let _id = node[this.methodGetNodeIdName(node)]

        if (
          (_isDept && this.disabledDeptIds.includes(_id)) ||
          this.disabledMemberIds.includes(_id)
        ) {
          _result = true
        }

        return _result
      }
    },
    /**
     * 计算当前节点是否已勾选
     */
    computedIsSelected(node) {
      return node => {
        let _result = this.methodFindNodeIndex(node) !== -1
        return _result
      }
    },
    /**
     * 计算当前节点是否可展开
     */
    computedIsCanOpen(node) {
      return node => {
        let _result = false
        if (this.selectType === SELECT_TYPE.none) {
          _result = node.deptType !== this.endType
        } else {
          // 校区列表可选
          if (node.deptType === NODE_TYPE.root) {
            _result = true
          } else {
            _result =
              this.selectType === 5
                ? node.deptType !== 5
                : node.deptType !== this.selectType
          }
        }
        return _result
      }
    },
    /**
     * 计算当前节点是否需要展示头像
     */
    computedIsShowHeadImg(node) {
      return node => {
        let _result = false
        if (node.deptType === SELECT_TYPE.members) {
          _result = true
        }

        return _result
      }
    },
    /**
     * 选择结果文本
     */
    computedResultText() {
      let _text = ''
      if (this.multiple) {
        let _deptCount = this.selectedDeptNodes.length
        let _memberCount = this.selectedMemberNodes.length
        if (_deptCount > 0 || _memberCount > 0) {
          _text += '已选择：'
          _deptCount > 0 && (_text += `${_deptCount}部门`)
          _memberCount > 0 && (_text += `${_memberCount}人`)
        }
      } else {
        this.selectedNode && (_text += `已选择：${this.selectedNode.name}`)
      }
      return _text
    },
    cpSelectedStudents() {
      let nodes = []
      if (this.multiple) {
        nodes = this.cpIsSelectDept
          ? this.selectedDeptNodes
          : this.selectedMemberNodes
      } else {
        nodes = [this.selectedNode]
      }
      return nodes
    }
  },
  watch: {
    isFocus() {
      document.getElementById('app').style.display = this.isFocus
        ? 'none'
        : 'block'
    }
  },
  beforeCreate() {},
  created() {
    pushNullUrl()
    setLeft(this.methodSetLeft)
  },
  beforeMount() {},
  mounted() {
    if (this.title) {
      mcSetTitle(this.title)
    }
    this.showCampusList =
      Object.prototype.toString.call(this.campus) === '[object Array]'
    // 传进来的是指定校区的话 就直接赋值
    if (this.showCampusList) {
      this.campus.length === 1 &&
        (this.currentCampus = Object.assign({}, this.campus[0]))
    } else {
      this.currentCampus = Object.assign({}, this.campus)
    }
    if (this.multiple) {
      this.selectedDeptNodes = [].concat(this.defaultSelectedDepts)
      this.selectedMemberNodes = [].concat(this.defaultSelectedMembers)
    }
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    removeLeft(this.methodSetLeft)
  },
  destroyed() {},
  methods: {
    /**
     * 人脸组件初始化
     */
    init() {
      this.nodeNav = []
      switch (this.role) {
        case LEAVE_ROLE.customRole:
        case LEAVE_ROLE.admin:
          if (this.showCampusList && this.campus.length > 1) {
            this.methodUpdateNodeNav({
              tpId: this.corpId,
              name: this.corpName,
              deptType: NODE_TYPE.root
            })
            this.depts = this.campus.reduce((_list, item) => {
              return _list.concat({
                ...item,
                deptType: NODE_TYPE.root
              })
            }, [])
          } else {
            this.methodUpdateNodeNav({
              tpId: this.currentCampus.tpId,
              name: this.currentCampus.name,
              deptType: NODE_TYPE.campus
            })
            this.fetchGetDeptList({
              deptType: 0,
              parentDeptId: this.currentCampus.tpId
            })
              .then(list => {
                this.depts = this.updatedData(list, false)
              })
              .catch(err => {
                console.log('unhandledrejection', err)
              })
          }
          break
        case LEAVE_ROLE.headmaster:
        case LEAVE_ROLE.teacher:
          if (this.classList.length > 1) {
            this.methodUpdateNodeNav({
              tpId: '',
              name: '班级列表',
              deptType: SELECT_TYPE.dept
            })
            this.depts = this.classList.map(item => {
              let _item = { ...item }
              _item.deptType = NODE_TYPE.class
              _item.campusId = this.currentCampus.tpId
              return _item
            })
          } else {
            this.methodUpdateNodeNav({
              tpId: this.classList[0].tpId,
              name: this.classList[0].name,
              deptType: NODE_TYPE.class
            })
            this.fetchGetStudentList(this.classList[0])
              .then(list => {
                this.students = list
              })
              .catch(err => {
                console.log('unhandledrejection', err)
              })
          }
          break
        default:
          // 该方案需要时再使用，目前家长进入时，所有孩子和家长一起展示
          if (this.studentList.length > 1) {
            this.methodUpdateNodeNav({
              tpId: '',
              name: '学生列表',
              deptType: SELECT_TYPE.members
            })
            this.students = this.studentList.map(item => {
              let _item = {
                ...item,
                deptType: SELECT_TYPE.members,
                parentId: item.deptId,
                parentName: item.className,
                campusId: item.campusId,
                dingClassesId: item.tpClassId
              }
              return _item
            })
          }
          break
      }
    },
    /**
     * 返回目标节点
     */
    handlerToGoBackTargetNode(_node, _index) {
      if (_index === 0) {
        this.init()
      } else {
        this.nodeNav.splice(_index + 1, this.nodeNav.length - _index - 1)
        this.$nextTick(() => {
          this.fetchGetDeptList(_node)
            .then(depts => {
              this.depts = this.updatedData(depts, _node)
              this.methodUpdatecurrentType(
                this.nodeNav[this.nodeNav.length - 1].deptType,
                _index
              )
            })
            .catch(err => {
              console.log('unhandledrejection', err)
            })
        })
      }
    },
    /**
     * 切换节点全选状态
     */
    handlerToChangeSelectAllStatus() {
      let _isSelectAll = this.compuedIsSelectedAll
      let _nodes = this.computedNodes
      _nodes.forEach(node => {
        if (this.computedIsDisabled(node)) {
          return
        }
        let _dept = this.methodCheckIsDept(node)
        let _index = this.methodFindNodeIndex(node)
        let _idName = this.methodGetNodeIdName(node)
        let _selectedNodes = _dept
          ? this.selectedDeptNodes
          : this.selectedMemberNodes
        if (!_isSelectAll && _index === -1) {
          if (
            this.returnType === RETURN_TYPE.none ||
            this.returnType === RETURN_TYPE.ding
          ) {
            _selectedNodes.push(node[_idName])
          } else {
            _selectedNodes.push(node)
          }
          if (node.deptType === SELECT_TYPE.class) {
            if (!this.allClassDetail.some(cl => cl.tpId === node.tpId)) {
              this.allClassDetail.push(node)
            }
          }
        } else if (_isSelectAll && _index !== -1) {
          _selectedNodes.splice(_index, 1)
          // 取消选择 且类型是班级 就从选中列表中去除
          if (node.deptType === SELECT_TYPE.class) {
            let _idx = this.allClassDetail.findIndex(
              cl => cl.tpId === node.tpId
            )
            if (_idx > -1) {
              this.allClassDetail.splice(_idx, 1)
            }
          }
        }
      })
    },
    /**
     * 切换节点勾选状态
     */
    async handlerToChangeSelectedStatus(node) {
      // let _node = {}
      // 节点不展示勾选框或不可操作时不做任何处理
      if (
        !this.computedIsShowSelectBox(node) ||
        this.computedIsDisabled(node)
      ) {
        return
      }
      if (this.multiple) {
        // 切换node勾选状态
        let _index = this.methodFindNodeIndex(node)
        let _selectedNodes = this.methodCheckIsDept(node)
          ? this.selectedDeptNodes
          : this.selectedMemberNodes
        if (_index !== -1) {
          _selectedNodes.splice(_index, 1)
          // 取消选择 且类型是班级 就从选中列表中去除
          if (node.deptType === SELECT_TYPE.class) {
            let _idx = this.allClassDetail.findIndex(
              cl => cl.tpId === node.tpId
            )
            if (_idx > -1) {
              this.allClassDetail.splice(_idx, 1)
            }
          }
        } else {
          if (
            this.returnType === RETURN_TYPE.none ||
            this.returnType === RETURN_TYPE.ding
          ) {
            let _id = node[this.methodGetNodeIdName(node)]
            _selectedNodes.push(_id)
          } else {
            _selectedNodes.push(node)
          }
          if (node.deptType === SELECT_TYPE.class) {
            if (!this.allClassDetail.some(cl => cl.tpId === node.tpId)) {
              this.allClassDetail.push(node)
            }
          }
        }
      } else {
        this.selectedNode = node
        this.allClassDetail = [node]
      }
    },
    /**
     * 获取直属子节点
     */
    handlerToGetSubNodes(node) {
      // 当前节点已勾选或不可操作时，点击无效，不展示子节点
      if (this.computedIsSelected(node) || this.computedIsDisabled(node)) {
        return
      }
      // @todo 搜索学生时处理
      if (this.searchKey) {
        // 获取学生和家长
        this.currentType = SELECT_TYPE.members
        if (this.role === LEAVE_ROLE.admin) {
          // @todo  节点deptId和name属性名追加
          this.fetchGetStudentBaseInfo(node)
            .then(studentBaseInfo => {
              this.$set(node, 'tpParentId', studentBaseInfo.classId)
            })
            .catch(err => {
              console.log('unhandledrejection', err)
            })
        }
        return
      }
      // 查询校区下面的学区
      if (node.deptType === NODE_TYPE.root) {
        this.methodUpdateNodeNav({
          tpId: node.tpId,
          name: node.name,
          deptType: NODE_TYPE.campus
        })
        // 根据选择的校区重置信息
        this.currentCampus = Object.assign({}, node)
        // 自定义校区选到人是5 经典校区是4 做好矫正 因为外面不知道里面选择是自定义校区还是经典校区 只能指定一种 此处做兼容
        if (this.selectType === 4) {
          this.selectType = 5
        }
        // 重置学生
        this.students = []
        this.fetchGetDeptList({
          deptType: 0,
          parentDeptId: node.tpId
        })
          .then(list => {
            this.depts = list
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
        return
      }

      this.methodUpdateNodeNav(node)
      if (node.deptType === SELECT_TYPE.class) {
        // 获取学生列表
        this.fetchGetStudentList(node)
          .then(list => {
            this.students = list
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      } else {
        this.students = []
        // 获取部门列表
        this.fetchGetDeptList(node)
          .then(list => {
            this.depts = this.updatedData(list, node)
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    updatedData(list, node) {
      if (!(this.rangeList || []).length) {
        return list
      }
      for (let index = 0; index < list.length; index++) {
        const element = list[index]
        element.isChecked = true

        for (let y = 0; y < this.rangeList.length; y++) {
          const item = this.rangeList[y]
          if (item.pathId.includes(element.tpId)) {
            element.allowed = true
          }
        }
      }
      // 如果上一层存在，并且没有对应的班级节点，所有班级全选
      if (node && node.allowed && !list.find(v => v.allowed)) {
        list.map(v => (v.allowed = true))
      }
      return list
    },
    /**
     * 搜索学生姓名
     */
    handlerToSearchMembers(searchKey) {
      this.searchKey = searchKey
      this.currentType = SELECT_TYPE.members
      if (!this.searchKey) {
        this.currentType = this.currentTypeBase
        this.searchMembers = []
        return
      }
      this.fetchGetStudentsBySearchKey(searchKey)
        .then(res => {
          this.searchMembers = res
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        }) // 新接口
    },
    // 留堂自用timer取消
    cancelTimer() {
      this.showTimer = false
    },
    // 留堂自用timer确认
    confirmTimer(index, value) {
      this.showTimer = false
      const _timeNow = new Date().getTime()
      const _timeSet = new Date(
        timeFormat(new Date(), `YYYY/MM/DD ${value[0]}:${value[1]}`)
      ).getTime()
      if (_timeNow > _timeSet) {
        return mcToast({ msg: '留堂时间应大于当前时间' })
      }
      this.handlerToSubmit(true, `${value[0]}:${value[1]}`)
    },
    /**
     * 提交选择信息
     */
    handlerToSubmit(immediate = false, timer = '') {
      /* eslint-disable */
      let _result = this.multiple
        ? {
            depts: this.selectedDeptNodes,
            members: this.selectedMemberNodes
          }
        : this.selectedNode
      /* eslint-enable */
      if (this.multiple && this.selectType === SELECT_TYPE.class) {
        _result.allClass = this.allClassDetail
      }
      // 限定情况：自定义角色且自定义角色有范围，自定义角色整个校区，rangeList = []

      if (
        LEAVE_ROLE.customRole === this.role &&
        (this.rangeList || []).length &&
        this.multiple &&
        this.isAttendanceFilter
      ) {
        let target = []
        let originRangeIds = this.originRangeList.map(v => v.deptDingId)
        // 选中的node找不到
        let isSelectedParent = this.selectedDeptNodes.filter(
          item => !originRangeIds.includes(item.deptDingId)
        )
        // 如果存在父级选中，不在选中范围的，筛选
        if (isSelectedParent.length) {
          for (let index = 0; index < this.selectedDeptNodes.length; index++) {
            const element = this.selectedDeptNodes[index]
            // 范围ID存在直接跳过
            if (originRangeIds.includes(element.deptDingId)) {
              target.push(element)
            } else {
              // 范围不存在 查询
              this.originRangeList.filter(item => {
                if (
                  item.parentDingIds.split(',').includes(element.deptDingId)
                ) {
                  target.push({
                    name: item.deptName,
                    tpId: item.deptDingId,
                    ...item
                  })
                }
              })
            }
          }
          _result.selfDepts = target
        }
      }
      if (!_result) {
        return mcToast({ msg: '请选择' })
      }
      if (this.isDentention && !immediate) {
        if (
          !(this.selectedDeptNodes || []).length &&
          !(this.selectedMemberNodes || []).length &&
          !(this.selectedNode || []).length
        ) {
          return mcToast({ msg: '请选择' })
        }
        this.showTimer = true
        const _timer = minutesLater()
        this.defaultActive = [+_timer[0], +_timer[1]]
        this.$set(this.defaultActive, [+_timer[0], +_timer[1]])
      } else if (this.isFlexLeave && !immediate) {
        let that = this
        let nameString = _result.members.map(item => {
          return item.name
        })
        this.clearConfirm = this.$Dialog({
          type: 'confirm',
          title: '人员确认',
          content: `<div class="break-all">确认${nameString
            .slice(0, 50)
            .join('、')}等${nameString.length}人已进入滞留室。</div>`,
          cancelBtn: {
            color: '#171A1D',
            text: '取消'
          },
          onConfirm() {
            that.handlerToSubmit(true)
          }
        }).show()
      } else {
        if (this.role !== LEAVE_ROLE.guardian) {
          _result.campusId = (this.currentCampus || {}).tpId || ''
        }
        if (this.isDentention) {
          _result.timer = timer
        }
        // 多选不可以跨班
        if (
          this.multiple &&
          (this.role === LEAVE_ROLE.headmaster ||
            this.role === LEAVE_ROLE.classTeacher ||
            this.role === LEAVE_ROLE.admin) &&
          !this.isQingtian
        ) {
          if (this.limitMultiple) {
            if (_result.members.length > 50) {
              return mcToast({ msg: '请假人数不能超过50个' })
            }
            let classIds = new Set(
              _result.members.reduce(
                (list, cls) => list.concat(cls.classDingId),
                []
              )
            )
            if (classIds.size > 1) {
              return mcToast({
                msg:
                  (this.isDentention
                    ? '留堂添加'
                    : this.isFlexLeave
                    ? '滞留生托管'
                    : '批量请假') + '只支持单个班级'
              })
            }
          } else {
            if (_result.members.length > this.maxMember) {
              return mcToast({ msg: `人数不能超过${this.maxMember}个` })
            }
          }
        }
        this.close(deepCopy(_result))
      }
    },
    /**
     * 获取部门
     */
    fetchGetDeptList({
      deptType = 0,
      parentDeptId = this.currentCampus.tpId
    } = {}) {
      return new Promise((resolve, reject) => {
        mcShowPreloader({ text: '加载中' })
        API.getSubDept({
          deptType,
          parentDeptId,
          campusId: this.currentCampus.tpId
        })
          .then(res => {
            let _depts = this.methodDefaultNodes(res || [], null, deptType)
            _depts.forEach(item => {
              item.tpId = item.deptDingId
              item.name = item.deptName
              item.parentDeptId = item.deptDingId
            })
            // 经典校区
            if (
              deptType === 0 &&
              typeof this.cacheDeptCallback === 'function'
            ) {
              this.cacheDeptCallback(res)
            }
            resolve(_depts)
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            mcHidePreloader()
          })
      })
    },
    /**
     * 获取学生列表
     */
    fetchGetStudentList(studentClass) {
      let _postData = {
        classDingId: studentClass.tpId,
        returnExtFields: [
          'campusId',
          'classDingId',
          'className',
          'deptId',
          'studentDingId',
          'studentName',
          'memberId',
          'accommodationTagName',
          'gender',
          'dormName'
        ]
      }
      return new Promise(async (resolve, reject) => {
        try {
          mcShowPreloader({ text: '加载中' })
          let _studentList = await API.getClassStudentInfo(_postData)
          _studentList.forEach(item => {
            item.tpId = item.studentDingId
            item.name = item.studentName
            item.deptType = SELECT_TYPE.members
            item.tpParentId = studentClass.tpId
            item.tpClassId = studentClass.tpId
            item.parentId = studentClass.deptId
            item.classId = studentClass.deptId
            item.parentName = studentClass.deptName
            item.className = studentClass.deptName
          })
          _studentList = this.methodDefaultNodes(
            _studentList || [],
            studentClass,
            NODE_TYPE.student
          )
          resolve(_studentList)
        } catch (err) {
          console.log(err)
        } finally {
          mcHidePreloader()
        }
      })
    },
    /**
     * 搜索学生（走通用通讯录接口，非家校）
     */
    fetchGetStudentsBySearchKey(searchKey) {
      return new Promise(async (resolve, reject) => {
        if (searchKey === '') {
          return
        }
        mcShowPreloader()
        let _postData = {
          campusId: this.currentCampus.tpId,
          liveInOnly: this.liveInOnly,
          limit: 30,
          q: searchKey,
          returnExtFields: [
            'accommodationTagName',
            'className',
            'gender',
            'dormName',
            'deptId'
          ]
        }
        let _roleTypeList = getCombineRole(+this.role, 'addressList')

        // 类型为请假或者禁用自定义角色时，剔除自定义角色
        if ([1, 3].includes(this.addressType) || this.disabledCustomRole) {
          _roleTypeList = _roleTypeList.filter(
            item => item !== LEAVE_ROLE.customRole
          )
        }
        // 禁用任课老师
        if (this.disabledTeacher) {
          _roleTypeList = _roleTypeList.filter(
            item => item !== LEAVE_ROLE.teacher
          )
        }
        _postData.roleTypeList = _roleTypeList

        let _studentList = await API.searchByName(_postData)
        mcHidePreloader()
        _studentList.forEach(item => {
          item.campusId = this.currentCampus.tpId
          item.tpClassId = item.classDingId
          item.tpId = item.studentDingId
          item.name = item.studentName
          item.deptType = SELECT_TYPE.members
        })
        resolve(_studentList)
      })
    },
    /**
     * 更新当前层级(仅限非搜索状态)
     */
    methodUpdatecurrentType(type = 0) {
      this.currentType = type
      this.currentTypeBase = type
    },
    /**
     * 更新部门导航条
     */
    methodUpdateNodeNav(node, index) {
      if (index !== undefined && index > -1) {
        this.nodeNav = this.nodeNav.slice(0, index + 1)
      } else {
        let _flag = this.nodeNav.some(item => item.tpId === node.tpId)
        if (!_flag) {
          this.nodeNav.push(node)
        }
      }
      this.methodUpdatecurrentType(
        /* eslint-disable */
        node.deptType === 3 ? SELECT_TYPE.members : node.deptType
        /* eslint-enable */
      )
    },
    /* 1
     * 查询已勾选节点index
     */
    methodFindNodeIndex(node) {
      let _index = -1
      let _idName = this.methodGetNodeIdName(node)

      if (this.multiple) {
        let _isDept = this.methodCheckIsDept(node)
        let _selectedNodes = _isDept
          ? this.selectedDeptNodes
          : this.selectedMemberNodes
        if (
          this.returnType === RETURN_TYPE.none ||
          this.returnType === RETURN_TYPE.ding
        ) {
          _index = _selectedNodes.findIndex(id => id === node[_idName])
        } else {
          _index = _selectedNodes.findIndex(
            item => item[_idName] === node[_idName]
          )
        }
      } else {
        _index =
          this.selectedNode && this.selectedNode[_idName] === node[_idName]
            ? 0
            : -1
      }

      return _index
    },
    /**
     * 判断当前节点是否是部门节点
     */
    methodCheckIsDept(node) {
      return node.deptType !== SELECT_TYPE.members
    },
    /**
     * 获取当前节点Id对应属性名
     */
    methodGetNodeIdName(node) {
      if (this.isQingtian) {
        return this.methodCheckIsDept(node) ? 'deptId' : 'memberId'
      }
      /* eslint-disable */
      let _idName =
        this.returnType === RETURN_TYPE.ding ||
        this.returnType === RETURN_TYPE.dingNode
          ? 'tpId'
          : this.methodCheckIsDept(node)
          ? 'deptId'
          : 'memberId'
      /* eslint-enable */
      return _idName
    },
    /**
     * 初始化节点
     */
    methodDefaultNodes(nodes, parent, type) {
      let _nodes = nodes.map(item => {
        // 节点基本信息
        let _node = { ...item }
        // 父节点信息
        if (parent) {
          _node.tpParentId = parent.tpId
          _node.parentId = parent.deptId
          _node.parentName = parent.name
          // 节点为学生时
          if (type === NODE_TYPE.student) {
            _node.classId = parent.deptId
            _node.tpClassId = parent.tpId
            _node.className = parent.name
          }
        }
        return _node
      })
      return _nodes
    },
    /**
     * 退回拦截
     */
    methodSetLeft() {
      pushNullUrl()
      if (this.showConfirm) {
        return false
      }
      this.showConfirm = true
      mcConfirm({ msg: '确认退出此操作吗?', closeOnPopstate: false })
        .then(btnIndex => {
          if (btnIndex === 1) {
            this.closeOnly()
          } else {
            this.showConfirm = false
          }
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    // 查看已选学生
    async handlerViewDetail() {
      if (
        !this.canViewDetail ||
        (this.viewDetailFlag && !this.computedResultText)
      ) {
        return
      }
      this.showSelectDetail = true
    }
  }
}
</script>

<style lang="scss" scoped>
.address-book {
  width: 100%;
  height: 100%;
  background: #f6f6f6;
  padding-bottom: 45px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  .bg-no-data {
    background: #f6f6f6;
  }
  .icon-no-data {
    width: 70px;
    height: 70px;
    background: url('~@/assets/images/staying-student.png');
    background-size: cover;
  }
  > div {
    width: 100%;
    padding: 0 16px;
    background: #ffffff;
    &:first-child {
      ~ div {
        margin-top: 8px;
      }
    }
    &.node-nav {
      background: #f6f6f6;
      margin: 0;
      &.mt-10 {
        margin-top: 8px;
      }
    }
    &.select-all {
      height: 48px !important;
      min-height: 48px;
      line-height: 48px;
    }
    &.node-list {
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      max-height: 80vh;
      > div {
        // height: 68px;

        &:last-child {
          border-bottom: none;
        }
        &.disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
        .next {
          color: #006afe;
          padding-left: 8px;
          border-left: 1px solid rgba(#191f25, 0.12);
          &.disabled-choose {
            cursor: not-allowed;
            opacity: 0.5;
          }
        }
      }
    }
    &.result {
      height: 45px;
      color: #006afe;
      border-top: 1px solid rgba(#191f25, 0.12);
      position: absolute;
      left: 0;
      bottom: 0;
    }

    &.no-data {
      width: 100%;
      height: 100%;
      background: none;
      > span:first-child {
        margin-bottom: 0.4rem;
      }
    }
  }
}
</style>
